import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { PublicPageFrame } from "../../components/layout/PublicPageFrame";

export function PagoOkPage() {
  const [searchParams] = useSearchParams();
  const seguroId = searchParams.get("seguro");

  return (
    <PublicPageFrame>
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
        <CheckCircle className="mx-auto h-16 w-16 text-green-600" aria-hidden />
        <h1 className="mt-4 text-xl font-semibold text-[#2C2C2C]">Pago realizado correctamente</h1>
        <p className="mt-2 text-gray-600">
          {seguroId ? `Tu seguro #${seguroId} ha sido confirmado.` : "Tu pago ha sido confirmado."}
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-block rounded-lg bg-[#1A3AB8] px-4 py-2.5 font-medium text-white hover:bg-[#15308a]"
        >
          Ver mis seguros
        </Link>
      </div>
    </PublicPageFrame>
  );
}
